<template>
  <div class="Evaluation-modal-overlay">
    <div class="Evaluation-modal" @click.stop>
      <div class="modal-content">
        <h2>Edit Session ID: {{ newProject.project_id }}</h2>

        <div class="add">
          <form @submit.prevent="updateProject">
            <!-- <div class="form-group">
              <label for="role">Product:</label>
              <select class="form-control rounded" id="prod_id" name="prod_id" 
              v-model="newProject.product_id" @change="fetchProjectsByProduct">
                <option value=""></option>
                <option v-for="product in products" :key="product.prod_id" :value="product.prod_id">
                  {{ product.name }}</option>
              </select>
            </div> -->
            <div class="form-group">
              <label for="start_date">Start Date:</label>
              <input type="date" class="form-control rounded" id="start_date" name="start_date" placeholder="DD/MM/YYYY"
                v-model="newProject.start_date" />
            </div>
            <div class="form-group">
              <label for="end_date">End Date:</label>
              <input type="date" class="form-control rounded" id="end_date" name="end_date" placeholder="DD/MM/YYYY"
                v-model="newProject.end_date" />
            </div>
            <div class="form-group">
              <label for="location">Location:</label>
              <input type="text" class="form-control rounded" id="location" name="location" placeholder="Enter Location"
                v-model="newProject.location" />
            </div>
            <div class="form-group">
              <label for="name">Name:</label>
              <input type="text" class="form-control rounded" id="name" name="name" placeholder="Enter Session Name"
                v-model="newProject.name" />
            </div>
            <div class="form-group">
            <button type="button" class="ins-assign-button" @click="viewAssignInstructors">Assign Instructors</button>
            <button type="button" class="ins-assign-button" @click="viewAssignTrainees">Assign Trainees</button>
          </div>
            <div v-if="showAlert" class="alert alert-danger error-message" role="alert">
              <div v-if="errorMessage" class="error-message">{{ errorMessage }}</div>
            </div>
            <div class="button-container">
            <button class="ins-close-button" @click="close()">Close</button>
            <button class="btn btn-primary rounded" type="submit" style="margin-right: 5%;">Update Session</button>
          </div>
          </form>
        </div>
      </div>
      <assign-trainee-modal v-if="showAssignTraineeModal" :selectedProjectId="selectedProjectId" @close="closeAssignTraineeModal"></assign-trainee-modal>
      <assign-instructor-modal v-if="showAssignInstructorModal" :selectedProjectId="selectedProjectId" @close="closeAssignInstructorModal"></assign-instructor-modal>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AssignTraineeModal from './AssignTraineeModal.vue';
import AssignInstructorModal from './AssignInstructorModal.vue';

export default {
  name: 'EditProjectModal',
  components: {
    AssignTraineeModal,
    AssignInstructorModal,
  },
  data() {
    return {
      instructors: [],
      products: [],
      projects: [],
      newProject: {
        name: '',
        start_date: '',
        end_date: '',
        location: '',
        prod_id: '',
        product_name: '',
      },
      showAlert: false,
      currentTime: '',
      errorMessages: {},
      errorMessage: '',
      productSelected: false,
      projectSelected: false,
      showTraineeList: false,
      showAssignTraineeModal: false,
      showAssignInstructorModal: false,
      selectedProjectId: localStorage.getItem('project_id')
    };
  },
  methods: {

    async updateProject() {
      try {
        const project_id = localStorage.getItem('project_id');
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };
        console.log('prod_id')
        console.log(this.newProject);

        const response = await axios.put(
          `/api/projects/${project_id}`,
          {
            name: this.newProject.name,
            start_date: this.newProject.start_date,
            end_date: this.newProject.end_date,
            location: this.newProject.location,
            prod_id: this.newProject.prod_id,
            product_name: this.newProject.product_name,
          },
          { headers }
        );

        if (response.status === 200) {
          window.alert('Session updated Successfully');
          this.projects.push(response.data);
          this.newProject = {
            name: '',
            start_date: '',
            end_date: '',
            location: '',
            prod_id: '',
            product_name: '',
            instructor_id: '',
            instructor2_id: '',
          };
          this.errorMessage = '';
          this.showAlert = false;
        }
        await this.fetchProjects();
        window.location.reload();
      } catch (error) {
        console.error('Error updating Session:', error.response);
        if (error.isOffline === true) {
            this.$router.push({ name: 'ViewProjects' });
          return;
        }

        if (error.response && error.response.data && error.response.data.errors) {
          // Handle validation errors
          const validationErrors = error.response.data.errors;

          // Build an error message from the validation errors
          let errorMessage = 'Validation errors:';
          for (const field in validationErrors) {
            errorMessage += `\n${field}: ${validationErrors[field][0]}`;
          }

          this.errorMessage = errorMessage;
        } else {
          // Handle other errors
          this.errorMessage = 'An error occurred while adding the user.';
        }

        this.showAlert = true;
      }
    },
    async fetchProjects() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.display('unauthorized');
          return;
        }

        const headers = {
          Authorization: `Bearer ${token}`,
        };

        const response = await axios.get('/api/projects', { headers });
        console.log('project response')
        console.log(response);

        if (response.status === 200) {
          this.projects = response.data;
          console.log('projects');
          console.log(this.projects);
        }
      } catch (error) {
        console.error('Error retrieving Sessions:', error);
        // Handle error
      }
    },
    async fetchProducts() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.display('unauthorized');
          return;
        }

        const headers = {
          Authorization: `Bearer ${token}`,
        };

        const response = await axios.get('/api/products', { headers });

        if (response.status === 200) {
          this.products = response.data; // Populate the products array with API data
          console.log('this products')
          console.log(this.products);
        }
      } catch (error) {
        console.error('Error retrieving products:', error);
        // Handle error
      }
    },
    async fetchInstructors() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          console.display('unauthorized');
          return;
        }

        const headers = {
          Authorization: `Bearer ${token}`,
        };

        const response = await axios.get('/api/users', { headers });

        if (response.status === 200) {
          // Filter the response data to include only users with the role 'instructor'
          this.instructors = response.data.filter(user => user.role === 'instructor');
          console.log(this.instructors);
        }
      } catch (error) {
        console.error('Error retrieving instructors:', error);
        // Handle error
      }
    },
    goBack() {
      this.$router.push({ name: 'ViewProjects' });
    },
    close() {
      this.$emit('close'); // Emit an event to indicate the modal should be closed
    },
    async getProjectData(project_id) {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      try {
        const res = await axios.get(`/api/projects/${project_id}`, { headers });
        const projectData = res.data.project;

        // Convert date format from DD/MM/YYYY to YYYY-MM-DD
        const formatDate = (date) => {
          const [day, month, year] = date.split('/');
          return `${year}-${month}-${day}`;
        };

        this.newProject = {
          ...projectData,
          start_date: projectData.start_date ? formatDate(projectData.start_date) : '',
          end_date: projectData.end_date ? formatDate(projectData.end_date) : '',
        };
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    },
    viewAssignTrainees() {
      this.showAssignTraineeModal = true; // Show the modal when the button is clicked
    },
    closeAssignTraineeModal() {
      this.showAssignTraineeModal = false; // Close the modal
    },
    viewAssignInstructors() {
      this.showAssignInstructorModal = true; // Show the modal when the button is clicked
    },
    closeAssignInstructorModal() {
      this.showAssignInstructorModal = false; // Close the modal
    },
  },
  async mounted() {
    this.getProjectData(localStorage.getItem('project_id'));
    await this.fetchInstructors();
    await this.fetchProjects();
    this.fetchProducts();

  },
}
</script>

<style scoped>
h2 {
  margin-top: 30px;
  font-size: 30px;
  margin-bottom: 30px;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-body {
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}

.confirm-button,
.cancel-button {
  padding: 10px 15px;
  margin-left: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-button {
  background-color: #28a745;
  color: white;
}

.cancel-button {
  background-color: #dc3545;
  color: white;
}

.trainee-table {
  width: 100%;
  border-collapse: collapse;
}

.trainee-table th,
.trainee-table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.trainee-table th {
  background-color: #f4f4f4;
}

.Evaluation-modal-overlay {
  position: absolute;
  top: 0px;
  left: 0;
  background-color: rgba(97, 94, 94, 0.5);
  display: flex;
  justify-content: center;
  width: 100%;
  height: 100vh;
  z-index: 1;
}

.Evaluation-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  margin-top: 85px;
  max-width: 90vw;
  max-height: 85vh;
  min-width: max(60vw, 1000px);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 1002;
}

.modal-title {
  text-align: center;
  margin-bottom: 20px;
}


@media (max-width: 768px) {

  /* Adjust the max-width as needed for iPad or other tablet sizes */
  .Evaluation-modal {
    padding: 5px;
    font-size: 0.9em;
    /* Reduce font size */
  }

  /* Further adjustments for other elements */
}


.alert-danger {
  color: #ff0019;
  background-color: #f8d7da;
  border: 1px solid #e6b0b6;
}

.alert {
  position: relative;
  padding: .75rem 1.25rem;
  margin-bottom: 0rem;
  border: 1px solid transparent;
  border-radius: .25rem;
}



button.btn:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

input.form-control,
select.form-control {
  width: 75%;
  margin-left: 150px;
  display: inline-block;
  margin-bottom: 15px;
  align-items: baseline;
}

.form-group {
  margin-bottom: 15px;
}

label {
  margin-right: 25px;
  position: absolute;
  margin-top: 8px;
  font-size: 16px;

}

.form-control {
  border-radius: 5px;
}

.form-control#start_date,
.form-control#end_date {
  border-radius: 5px;
  width: 25%;
  margin-left: 150px;
  margin-right: 50%;
}

h1 {
  margin-bottom: 50px;
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
  margin-top: 10px;
  /* Adjust as needed */
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  width: 120px;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 5%;
}

.ins-close-button:hover {
  background-color: #4d5358;
}

.logbook-details-box {
  border: 2px solid #858585;
  border-radius: 5px;
  margin: 3px auto;
  min-width: 95%;
  max-width: 95%;
  padding: 7px;
}


.cell-header {
  font-weight: bold;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  font-size: 12px;
  background-color: #707070;
  padding: 2px 5px;
  color: white;
  border-radius: 2px;
  margin-bottom: 0px;
  /* Set margin-right */
  text-align: left;
  display: inline-block;
  width: auto;
}

.logbook-details {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.trainee-container {
  display: flex;
  flex-wrap: wrap;
  /* Allows wrapping */
}

.trainee-box {
  display: inline-block;
  padding: 4px 12px;
  margin: 3px;
  border-radius: 8px;
  background-color: #f0f0f0;
  border: 1px solid #ccc;
  text-align: center;
  white-space: nowrap;
  font-size: 14px;
}

.ins-assign-button {
  margin-top: 0px;
  margin-bottom: 0px;
  margin-left: 15px;
  margin-right: 15px;
  border-radius: 5px;
  background-color: rgb(53, 131, 37);
  border: 1px solid rgb(26, 82, 16);
}

.ins-assign-button:hover {
  background-color: rgb(48, 112, 35);
  border: 1px solid rgb(23, 77, 13);
}
</style>